import { endpoints, request } from '!core/api';

export const languagesServices = {
  changeLanguage: ({ languageId }) =>
    request.put(endpoints.framework(`ChangeLanguage`), { languageId }),
};
